'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
const vue_1 = require('vue')
const _hoisted_1 = {
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 48 48'
}
const _hoisted_2 = /*#__PURE__*/ (0, vue_1.createElementVNode)(
  'g',
  {
    fill: 'none'
  },
  [
    /*#__PURE__*/ (0, vue_1.createElementVNode)('path', {
      d: 'M24 39c8.284 0 15-6.716 15-15c0-.483-.023-.96-.067-1.43c-.078-.817.534-1.57 1.354-1.57c.845 0 1.576.61 1.647 1.452c.044.51.066 1.026.066 1.548c0 9.941-8.059 18-18 18S6 33.941 6 24S14.059 6 24 6c4.732 0 9.037 1.826 12.25 4.811V8.25a1.5 1.5 0 0 1 3 0v6.5a1.5 1.5 0 0 1-1.5 1.5h-6.5a1.5 1.5 0 0 1 0-3h3.211A14.951 14.951 0 0 0 24 9C15.716 9 9 15.716 9 24c0 8.284 6.716 15 15 15z',
      fill: 'currentColor'
    })
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
exports.default = (0, vue_1.defineComponent)({
  name: 'ArrowClockwise48Filled',
  render: function render(_ctx, _cache) {
    return (0, vue_1.openBlock)(), (0, vue_1.createElementBlock)('svg', _hoisted_1, _hoisted_3)
  }
})
